import * as types from '../constants/reportConstants';
import appConstants from '../appConstants';
import config from './../config.js';
import moment from 'moment';
const initialState = {
	reportData: [],
	alldealtbleData: [],
	activityData: [],
	statement_AccountData: [],
	positionData: {
		FUNDS: [],
		totFunds: null,
		totReval: null,
		totABSReval: null,
		totMargin: null,
		curr_NOP: null,
		loss_lmt: null,
		AppMargin: null,
		free_equ: null,
		STKA: [],
	},
	OnlinetbleData: [],
	BMData: [],
	loadRptFlag: false,
	modalFlag: false,
	nonDefAccBal: null,
	isUpdatePositionData:false
};
const updatePosition = (msg) => {
	return {
		totFunds: msg.Position[0].totFunds,
		totReval: msg.Position[0].totReval,
		totABSReval: msg.Position[0].totABSReval,
		totMargin: msg.Position[0].totMargin,
		curr_NOP: msg.Position[0].curr_NOP,
		loss_lmt: msg.Position[0].loss_lmt,
		AppMargin: msg.Position[0].AppMargin,
		free_equ: msg.Position[0].free_equ,
		MarginPer: msg.Position[0].MarginPer.replace("%", ""),
		UQFlag: msg.UQFlag,
		TQFlag: msg.TQFlag,
		OQFlag: msg.OQFlag,
		STKA: msg.STKA,
		FUNDS: msg.FUNDS,
		UAQTY: msg.UAQTY,
		ORQTY: msg.ORQTY,
		TQTY: msg.TQTY,
	}
}
const getDecimal = (cmdtypair) => {
	var dec;
	const item = Object.assign([], JSON.parse(localStorage.getItem(cmdtypair)));
	//for (let index = 0; index < item.length; index++) {
	// if (item[index].I === cmdtypair) {
	dec = item.dec
	//break;
	// }
	// }
	return dec;
}
const getAmntDecimal = (cmdtypair) => {
	const item = Object.assign([], JSON.parse(localStorage.getItem(cmdtypair)));
	var dec = item.amntDec;
	return dec;
}
export function marginCheckNotification(msg) {
	var obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NFD ? msg.NFD : "");
	if (parseInt(msg.OT) === 2) {
		obj.docNo = (msg.NOD
			? msg.NOD
			: "");
	} else if (parseInt(msg.OT) === 5) {
		obj.docNo = (msg.ONB
			? msg.ONB
			: "");
	}
	let remark = "";
	const type = (msg.OT
		? msg.OT
		: "1");
	const msgType = msg.OMT;
	if (parseInt(type) === 1) {
		remark = "Trade unsuccessful. "
	} else if (parseInt(msgType) === 2) {
		remark = "Modify unsuccessful. "
	} else if (parseInt(msgType) === 6) {
		remark = "Cancel unsuccessful. "
	}else {
		remark = "Order unsuccessful. "
	}
	switch (msg.STATUS) {
		case appConstants.TRD_ROUTE_ISSUE: remark = remark + "There's a problem with the price feed. Please contact your StoneX Trading Desk."; break;
		case appConstants.SESSION_EXP: remark = remark + "Your session has expired. Please login again."; break;
		case appConstants.REJ_ACCLOCKED: remark = remark + "Trade unsuccessful. Another trader is executing in this account."; break;
		case appConstants.MRG_FAILED: remark = remark + "Trade rejected. Insufficient margins."; break;
		case appConstants.NOP_BREACH: remark = remark + "This trade would breach your position limit. Please contact your StoneX Trading Desk."; break;
		case appConstants.WORST_NOP_BREACH: remark = remark + "The value of your position plus outstanding orders cannot exceed your NOP limit."; break;
		case appConstants.INVALID_DATE: remark = remark + "The expiry time you entered falls on a non-business day."; break;
		case appConstants.ORD_FILLED: remark = remark + "This order has already been filled and cannot be modified."; break;
		case appConstants.EXCEEDS_TRDLIMIT: remark = remark + "The size exceeds your per deal limit."; break;
		case appConstants.EXCEEDS_EXPOSURE: remark = remark + "The value exceeds your overall exposure limit."; break;
		case appConstants.INSUFFICIENT_MRG: remark = remark + "Your margin levels are insufficient."; break;
		case appConstants.EXCEEDS_ORDLIMIT: remark = remark + "The value exceeds your per deal limit."; break;
		case appConstants.EXCEEDS_MIN_QTYLIMIT: remark = remark + "Quantity Exceeds Max Hedge Quantity."; break;
		case appConstants.TRD_PROCESS_ISSUE: remark = remark + "Deal request could not be processed. Please try after some time.alert"; break;
		case appConstants.NO_DEALER: remark = remark + "There's no StoneX dealer available. Please contact your StoneX Trading Desk."; break;
		case appConstants.TRD_DISABLED: remark = remark + "This commodity is unavailable to you. Please contact your StoneX Trading Desk."; break;
		//case appConstants.TRD_ROUTE_ISSUE:remark = remark+"There's a problem with the price feed. Please contact your StoneX Trading Desk.";break;
		// case appConstants.SESSION_EXP:remark = remark+"Your session has expired. Please login again.";break;
		case appConstants.TRD_PLACE_FAIL: remark = remark + "Trade unsuccessful. Please try again."; break;
		//case appConstants.INVALID_DATE:remark = remark+"The expiry time you entered falls on a non-business day.";break;
		case appConstants.REJ_ACCLOCKED: remark = remark + "Trade unsuccessful. Another trader is executing in this account."; break;
		case appConstants.NOP_BREACH: remark = remark + "This trade would breach your position limit. Please contact your StoneX Trading Desk."; break;
		case appConstants.WORST_NOP_BREACH: remark = remark + "The value of your position plus outstanding orders cannot exceed your NOP limit."; break;
		//case appConstants.ORD_FILLED:remark = remark+"This order has already been filled and cannot be modified.";break;
		case appConstants.BM_NOT_VALID: remark = remark + "This benchmark is no longer available for new orders or modifications. \n Please contact your StoneX Dealing Desk."; break;
		case appConstants.MRK_ORD_CACNEL: remark = remark + "Trader cannot modify/cancel marked orders"; break;
		case appConstants.LOOP_ORDER_FAILED: remark = `OTO order loop failed. ${msg.MSG}`; break;
		default: remark = "Trade unsuccessful. Please try again."; break;
	}
	obj.remark = remark;
	return obj;
}
export function getDealRcvdLogRmk(msg, cmdtypair) {
	try {
		var obj = {};
		var dec = getAmntDecimal(msg.IID);
		const cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
		obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
		obj.docNo = (msg.NFD ? msg.NFD : "");
		let remark = "";
		remark = "Trade request received: ";
		//remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
		remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
		remark = remark + " " + Number((msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });//commBean.getSuffixFormat().format( To Ask Rekha mam
		remark = remark + " ";
		remark = remark + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
		remark = remark + " @";
		remark = remark + (msg.DR ? Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: cmdtyDet.amntMinDec, maximumFractionDigits: dec }) : "0");
		remark = remark + " ";
		remark = remark + (msg.ST !== undefined ? msg.ST : "");
		remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")})` : ""); 
		if (msg.AC)
			remark = remark + " for " + msg.AD;
		remark = remark + " [" + msg.UCD + "]";
		if (msg.RMK === undefined) {
			msg.RMK = "";
		}
		if (msg.RMK !== "" && msg.RMK !== " ")
			remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
		obj.remark = remark + ".";
		return obj;
	} catch (e) { console.log(e); }
}

export function getFWDTradeRcvdRemark(msg) {
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = msg.NFD ? msg.NFD : "";
	obj.remark = msg.MSG ? msg.MSG + "." : "";
	return obj;
  }

export function getLimitOrderreject(msg, cmdtypair) {
	var obj = {};
	var dec = getDecimal(msg.IID);
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NOD
		? msg.NOD
		: "");
	let remark = "";
	remark = remark + "Your Order request was unsuccessful: ";
	if (msg.OT === appConstants.STOP_ORD_TYPE) {
		remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "Stop BUY" : "Stop SELL");
	} else if (msg.OT === appConstants.OCO_ORD_TYPE) {
		let dealType = "";
		if (msg.DOT === appConstants.STOP_ORD_TYPE) {
			dealType = 'OCO Stop ' + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
		} else {
			dealType = 'OCO Limit ' + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
		}
		remark = remark + dealType;
	} else {
		remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
	}
	remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
	remark = remark + " " + (msg.SC !== undefined
		? msg.SC + " " + cmdtypair
		: cmdtypair);
	remark = remark + " @" + " " + (msg.R
		? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
		: "0") + " ";
	remark = remark + (msg.ST
		? msg.ST
		: "");
	remark = remark + (parseInt(msg.VT) === appConstants.GTD
		? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
		: (parseInt(msg.VT) === appConstants.DAY
			? "DAY: 1700 NYC"
			: "GTC"));

	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}

export function getFwdRateSubscriptionRejectMsg(msg) {
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = msg.NFD ? msg.NFD : "";
	obj.remark = msg.ERR ? msg.ERR : "";
	return obj;
}

export function getFwdOrdRejectMsg(msg){
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);;
	obj.docNo = msg?.NFD; 
	obj.remark = msg.MSG ? msg.MSG + "." : "";
	return obj;
}

export function getSwpOrdRejectMsg(msg){
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);;
	obj.docNo = ""; 
	obj.remark = msg.MSG
	return obj;
}

export function getRejectedDealLogRemark(msg, cmdtypair) {
	var obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NFD ? msg.NFD : "");
	var dec = getAmntDecimal(msg.IID);
	var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
	let remark = "";
	remark = remark + "Your trade request was unsuccessful: ";
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
	remark = remark + " " + Number((msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });//commBean.getSuffixFormat().format( To Ask Rekha mam
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + " @" + (msg.DR ? Number(parseFloat(msg.DR).toFixed(dec)).toLocaleString('en', { maximumFractionDigits: dec, minimumFractionDigits: cmdtyDet.amntMinDec }) : "0") + " "
	remark = remark + (msg.ST ? msg.ST : "");
	remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")})` : ""); 
	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getConfirmedDealLogRemark(msg, cmdtypair) {
	var obj = {};
	var dec = getAmntDecimal(msg.IID);
	var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));

	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NFD ? msg.NFD : "");
	let remark = "";
	remark = "Trade confirmed: "
	//remark=reamark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD");
	remark = remark + " " + Number((msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });//commBean.getSuffixFormat().format( To Ask Rekha mam
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + " @" + (msg.DR ? Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: cmdtyDet.amntMinDec, maximumFractionDigits: dec }) : "0") + " ";
	remark = remark + (msg.ST ? msg.ST : "");
	remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")})` : ""); 
	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}

export function getFWDTradeConfirmedRemark(msg){
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);;
	obj.docNo = msg?.NFD; 
	obj.remark = msg.MSG ? msg.MSG + "." : "";
	return obj;
}

export function getSWPTradeRcvdRemark(msg) {
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = "";
	obj.remark = msg.MSG ? msg.MSG + "." : "";
	return obj;
}

export function getSWPTradeConfirmedRemark(msg){
	let obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);;
	obj.docNo = msg?.SWC; 
	obj.remark = msg.MSG ? msg.MSG + "." : "";
	return obj;
}

export function getBmkOrderPlcRecd(msg, cmdtypair) {
	var obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.ONB ? msg.ONB : "");
	let remark = "";
	if (msg.OMT === appConstants.NEWORD) {
		remark = remark + "Benchmark Order Placed: ";
	} else if (msg.OMT === appConstants.MODORD) {
		remark = remark + "Benchmark Order Modified: ";
	} else if (msg.OMT === appConstants.CANCELORD) {
		remark = remark + "Benchmark Order Cancelled: ";
	}
	remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL") + " ";
	remark = remark + " " + Number(parseFloat(msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + (msg.ST ? msg.ST : "");
	const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
    if(isFwdEnableForBMK === true) {
	 let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
     remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;  
	}
	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getBmkOrderReqRecd(msg, cmdtypair) {
	var obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.ONB ? msg.ONB : "");
	let remark = "";
	if (msg.OMT === appConstants.NEWORD) {
		remark = remark + "Benchmark Order request received: ";
		remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
	} else if (msg.OMT === appConstants.MODORD) {
		remark = remark + "Modify Benchmark Order request received: ";
		remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
	} else if (msg.OMT === appConstants.CANCELORD) {
		remark = remark + " Cancel Benchmark Order request received: ";
		remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
	}
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
	remark = remark + " " + Number((msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + (msg.ST ? msg.ST : "");
	const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
    if(isFwdEnableForBMK === true) {
	let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
    remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;  
	}
	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "].";
	obj.remark = remark;
	return obj;
}
export function getBmkOrderFillRecd(msg, cmdtypair) {
	var obj = {};
	const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
	var dec = item.BMdec
	var mindec = item.BMminDec
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.FNC ? msg.FNC : "");
	let qty = (msg.OT === 5 ? msg.PQ : msg.QPF);
	let orderNo = (msg.OT === 5 ? msg.ONB : msg.AVG);
	let remark = "";
	remark = remark + (msg.OT !== 5 ? 'Avg ' : '') + "Benchmark Order Filled: ";
	remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD");
	remark = remark + " " + Number((qty).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + " @" + (msg.FP ? Number(parseFloat(msg.FP)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }) : 0) + " ";
	const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
    if(isFwdEnableForBMK === true) {
	let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
    remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;  
	}
	if (msg.AC)
		remark = remark + " For " + msg.AD;
	remark = remark + "(" + orderNo + ")";
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getLogginLogout(msg) {
	var obj = {};
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.FNC ? msg.FNC : "");
	obj.remark = msg.UCD + (msg.BCM === '7' ? " logged in. " : " logged out. ");
	return obj;
}
export function getLimitOrderReqRecd(msg, cmdtypair) {
	var obj = {};
	var dec = getDecimal(msg.IID);
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NOD
		? msg.NOD
		: "");
	let remark = "";
	let LoopdealType = `${msg?.INLOOP ? ' (L) ' : ' '}`;
	if (msg.OMT === appConstants.NEWORD) {
		remark = remark + "Order request received: ";
	} else if (msg.OMT === appConstants.MODORD) {
		remark = remark + "Modify Order request received: ";
	} else if (msg.OMT === appConstants.CANCELORD) {
		remark = remark + "Cancel Order request received: ";
	}
	let dealType = (parseInt(msg.DT) === appConstants.TRADER_BUY ? `BUY` : `SELL`)
	if (msg.OT === appConstants.STOP_ORD_TYPE) {
		remark = remark + `${msg.ISOTO ? 'OTO ' : ''}Stop${LoopdealType}` + dealType
	} else if (msg.OT === appConstants.OCO_ORD_TYPE) {
		remark = remark + (parseInt(msg.DOT) === appConstants.STOP_ORD_TYPE ? `${msg.ISOTO ? 'OTO ' : ''}OCO Stop ` : `${msg.ISOTO ? 'OTO ' : ''}OCO Limit `) + dealType;
	} else {
		remark = remark + `${msg.ISOTO ? 'OTO Limit': ''}${LoopdealType}`+ dealType;
	}
	remark = remark + " " + Number((msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
	remark = remark + " @" + " " + (msg.R
		? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
		: "0") + " ";
	remark = remark + (msg.ST
		? msg.ST
		: "");
	remark = remark + (parseInt(msg.VT) === appConstants.GTD
		? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
		: (parseInt(msg.VT) === appConstants.DAY
			? "DAY: 1700 NYC"
			: "GTC"));

	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getLimitOrderPlcRecd(msg, cmdtypair) {
	var obj = {};
	var dec = getDecimal(msg.IID);
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NOD
		? msg.NOD
		: "");
	let remark = "";
	let LoopdealType = `${msg?.INLOOP ? ' (L) ' : ''}`;
	if (msg.BCM === appConstants.ORD_PLACED && msg.OMT === appConstants.NEWORD) {
		remark = remark + "Order Placed: ";
	} else if (msg.BCM === appConstants.ORD_ACTIVATED) {
		remark = remark + "Order Activated: ";
	} else if (msg.BCM !== appConstants.ORD_ACTIVATED && msg.OMT === appConstants.MODORD) {
		remark = remark + "Order Modified: ";
	} else if (msg.OMT === appConstants.CANCELORD) {
		remark = remark + "Order Cancelled: ";
	}
	let dealType = (parseInt(msg.DT) === appConstants.TRADER_BUY ? `BUY` : `SELL`)
	if (msg.OT === appConstants.STOP_ORD_TYPE) {
		remark = remark + `${msg.ISOTO ? 'OTO ' : ''}Stop${LoopdealType} ` + dealType
	} else if (msg.OT === appConstants.OCO_ORD_TYPE) {
		remark = remark + (parseInt(msg.DOT) === appConstants.STOP_ORD_TYPE ? `${msg.ISOTO ? 'OTO ' : ''}OCO Stop ` : `${msg.ISOTO ? 'OTO ' : ''}OCO Limit `) + dealType;
	} else {
		remark = remark + `${msg.ISOTO ? 'OTO Limit ': ''}${LoopdealType}` + dealType;
	}

	if (msg.OMT === appConstants.CANCELORD) {
		let TFQ = (msg.TFQ !== undefined ? msg.TFQ : 0);
		let GQ = (msg.GQ !== undefined ? msg.GQ : msg.PQ);
		remark = remark + " " + (Number(parseFloat(GQ) - parseFloat(TFQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
	}
	else {
		remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
	}
	remark = remark + " " + (msg.SC !== undefined
		? msg.SC + " " + cmdtypair
		: cmdtypair);
	remark = remark + " @" + " " + (msg.R
		? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
		: "0") + " ";
	remark = remark + (msg.ST
		? msg.ST
		: "");
	remark = remark + (parseInt(msg.VT) === appConstants.GTD
		? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
		: (parseInt(msg.VT) === appConstants.DAY
			? "DAY: 1700 NYC"
			: "GTC"));

	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getLmtOrderFillRecd(msg, cmdtypair) {
	var obj = {};
	var orderStatus = (msg.OMT === 10 || msg.OMT === 5 ? "Order Filled" : "Order Partially Filled");
	let qty = (msg.OMT === 4 ? msg.FQ : msg.PQ);
	var dec = getDecimal(msg.IID);
	var amntDec = getAmntDecimal(msg.IID);
	var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NFD
		? msg.NFD
		: "");
	let remark = "";
	remark = remark + orderStatus + ": ";
	remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD")
	remark = remark + " " + Number(parseFloat(qty).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined
		? msg.SC + " " + cmdtypair
		: cmdtypair);
	remark = remark + " @" + " " + (msg.DR
		? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: cmdtyDet.amntMinDec, maximumFractionDigits: amntDec }))
		: "0") + " ";
	remark = remark + (msg.ST
		? msg.ST
		: "");
	remark = remark + (parseInt(msg.VT) === appConstants.GTD
		? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
		: (parseInt(msg.VT) === appConstants.DAY
			? "DAY: 1700 NYC"
			: "GTC"));

	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " (" + msg.NOD + ")";
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}
export function getLmtExpLog(msg, cmdtypair) {
	var obj = {};
	var dec = getDecimal(msg.IID);
	obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NOD
		? msg.NOD
		: "");
	let remark = "";
	remark = remark + "Order Expired: "
    let LoopdealType = `${msg?.INLOOP ? ' (L) ' : ' '}`;
	if (msg.OT === appConstants.STOP_ORD_TYPE) {
		remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}SELL`);
	} else if (msg.OT === appConstants.OCO_ORD_TYPE) {
        let dealType = "";
        if (msg.DOT === appConstants.STOP_ORD_TYPE) {
            dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Stop ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
        } else {
            dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Limit ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
        }
        remark = remark + dealType;
	} else {
        remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}SELL`);
	}

	remark = remark + " " + Number((parseFloat(msg.GQ) - parseFloat((msg.TFQ !== undefined ? parseFloat(msg.TFQ) : 0))).toFixed(config.QuantityRoundOff)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff });
	remark = remark + " " + (msg.SC !== undefined
		? msg.SC + " " + cmdtypair
		: cmdtypair);
	remark = remark + " @" + " " + (msg.R
		? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
		: "0") + " ";
	remark = remark + (msg.ST
		? msg.ST
		: "");
	remark = remark + (parseInt(msg.VT) === appConstants.GTD
		? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
		: (parseInt(msg.VT) === appConstants.DAY
			? "DAY: 1700 NYC"
			: "GTC"));

	if (msg.AC)
		remark = remark + " for " + msg.AD;
	remark = remark + " [" + msg.UCD + "]";
	if (msg.RMK === undefined) {
		msg.RMK = "";
	}
	if (msg.RMK !== "" && msg.RMK !== " ")
		remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
	obj.remark = remark + ".";
	return obj;
}

const getPayDecimal = (CCYG) => {
    let qtyDec;
    if (CCYG === 'M') {
      qtyDec = 3;
    } else {
      qtyDec = 2;
    }
    return qtyDec;
}

// Payment request messages
export function getPayReqLog(msg) {
    let defaultAC = JSON.parse(localStorage.getItem('DefaultAC'));
    if (msg.AC === defaultAC.AC) {
      let accDes = msg.AD;
      if (msg.AD === undefined) {
        if (defaultAC.AC === msg.AC) {
          accDes = defaultAC.AD;
        }
      }
  
      let qtyDec = getPayDecimal(msg.CCYG);
      if (msg.BCM === appConstants.PAYMENT_REQUEST_PLACED) {
  
        let obj = {};
        obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
        obj.docNo = (msg.DN
          ? msg.DN
          : "");
        let remark = '';
        if (msg.OMT === 1) {
          remark = 'Place Payment Request: ';
        } else if (msg.OMT === 2) {
          remark = 'Modify Payment Request: ';
        } else if (msg.OMT === 6) {
          remark = 'Cancel Payment Request: ';
        } else {
          remark = remark;
        }
        remark = remark + " For " + accDes + ", " + msg.CCYN + " " + parseFloat(msg.PQ).toLocaleString('en', { minimumFractionDigits: qtyDec });
        remark = remark + " [" + msg.UCD + "] ";
  
        obj.remark = remark;
        return obj;
      } else if (msg.BCM === appConstants.PAYMENT_REQ_UPDATE) {
        let obj = {};
        obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
        obj.docNo = (msg.DN
          ? msg.DN
          : "");
        let remark = '';
        if (msg.OMT === 1) {
          remark = 'Payment Request Placed: ';
        } else if (msg.OMT === 2) {
          remark = 'Payment Request Modified: ';
        } else if (msg.OMT === 6) {
          remark = 'Payment Request Cancelled: ';
        } else {
          remark = remark;
        }
        remark = remark + " For " + accDes + ", " + msg.CCYN + " " + parseFloat(msg.PQ).toLocaleString('en', { minimumFractionDigits: qtyDec, maximumFractionDigits: qtyDec });
        remark = remark + " [" + msg.PRUSER + "].";
        obj.remark = remark;
        return obj;
      } else if (msg.BCM === appConstants.PAYMENT_REQUEST_FAIL) {
        let obj = {};
        obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
        obj.docNo = (msg.DN
          ? msg.DN
          : "");
        let remark = '';
        if (msg.OMT === 1) {
          remark = 'Payment request failed. ';
        } else if (msg.OMT === 2) {
          remark = 'Modify payment request Failed. ';
        } else if (msg.OMT === 6) {
          remark = 'Cancel Payment request failed. ';
        } else {
          remark = remark;
        }
        remark = remark + (msg.MSG ? msg.MSG : "");
        //remark = remark + " For " + accDes ; //+", "+msg.CCYN +" "+(parseFloat(msg.PQ).toFixed(config.QuantityRoundOff));
        //remark = remark +" ["+ msg.UCD + "] ";
        obj.remark = remark;
        return obj;
      } else if (msg.BCM === appConstants.PAYMENT_REQUEST_APRVREJ) {
        let obj = {};
        obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
        obj.docNo = (msg.DN
          ? msg.DN
          : "");
        let RSC = '';
        if (msg.RSC === 'APR') {
          RSC = 'Approved';
        } else if (msg.RSC === 'CMPLT') {
          RSC = 'Completed';
        } else {
          RSC = 'Rejected';
        }
        let remark = 'Your Payment Request ' + RSC + ".";
        remark = remark + (msg.MSG ? msg.MSG : "");
        remark = remark + " for " + accDes + ", " + msg.CCYN + " " + (parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: qtyDec, maximumFractionDigits: qtyDec });
        remark = remark + " [" + msg.PRUSER + "].";
        obj.remark = remark;
        return obj;
      }
    }
  }

const generateactivityData = (notificationList) => {
	var arrayObj = [];
	try {
		notificationList.map((item, index) => {
			let cmdtypair = "";
			if (item.BCM !== appConstants.TRD_LOGIN && item.BCM !== appConstants.TRD_LOGOUT) {
				const socketData = Object.assign([], JSON.parse(localStorage.getItem(item.IID)));
				cmdtypair = socketData.ID
			}
			switch (item.BCM) {
				case appConstants.INITIAL_CHECKS_FAILED:
				case appConstants.MARGIN_CHECKS_FAILED: 
                    var obj = marginCheckNotification(item); obj && arrayObj.push(obj); break; //dispatch(break;
				case appConstants.TRADE_REQUEST_RECEIVED: 
				 if(item.isForward) {
					var obj = getFWDTradeRcvdRemark(item);
					obj && arrayObj.push(obj); break;
				 } else {
					var obj = getDealRcvdLogRmk(item, cmdtypair); 
					obj && arrayObj.push(obj); break;
				 }
				case appConstants.TRADE_REQUEST_REJCTED: var obj = getRejectedDealLogRemark(item, cmdtypair); obj && arrayObj.push(obj); break;
				case appConstants.TRADE_REQUEST_CONFIRMED: 
				 if(item.isForward) {
					var obj = getFWDTradeConfirmedRemark(item)
					obj && arrayObj.push(obj); break;
				 } else {
				    var obj = getConfirmedDealLogRemark(item, cmdtypair); 
				    obj && arrayObj.push(obj); break;
				 }
                case appConstants.BENCHMARK_REQ_RECD:
				case appConstants.BENCHMARK_MOD_REQ_RECD:
				case appConstants.BENCHMARK_CANC_REQ_RECD: 
                    var obj = getBmkOrderReqRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.BM_PLACED:
                case appConstants.BM_MODIFIED:
                case appConstants.BM_CANCELLED: 
                    var obj = getBmkOrderPlcRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.BENCHMARK_MANUAL_FILL: 
                    var obj = getBmkOrderFillRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.TRD_LOGIN:
				case appConstants.TRD_LOGOUT: 
                    var obj = getLogginLogout(item); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.ORD_PLACED:
				case appConstants.ORD_ACTIVATED:
                case appConstants.ORD_CANCEL:
                case appConstants.ORD_MODIFIED: 
                    var obj = getLimitOrderPlcRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.MODIFY_REQ_RECD:
				case appConstants.ORD_CANCEL_REQUEST: 
				case appConstants.ORD_REQ_RECD: 
                    var obj = getLimitOrderReqRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.ORD_HEDGE_FILL:
				case appConstants.ORD_UNHEDGE_FILL: 
                    var obj = getLmtOrderFillRecd(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.ORDER_EXPIRED:
				case appConstants.ORDER_UNHEDGE_EXPIRED:
                    var obj = getLmtExpLog(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.ORDER_REQUEST_REJECT:
				case appConstants.REQUEST_REJECT: 
                    var obj = getLimitOrderreject(item, cmdtypair); 
                    obj && arrayObj.push(obj); break;
				
                case appConstants.PAYMENT_REQUEST_PLACED:
				case appConstants.PAYMENT_REQ_UPDATE:
				case appConstants.PAYMENT_REQUEST_FAIL:
				case appConstants.PAYMENT_REQUEST_APRVREJ:
                    var obj = getPayReqLog(item); 
                    obj && arrayObj.push(obj); break;
				
				case appConstants.FIX_RATE_SUBSCRIPTION_REJECTED:
				    var obj = getFwdRateSubscriptionRejectMsg(item); 
				    obj && arrayObj.push(obj); break;

				case appConstants.FWD_ORD_REJECT:
				    var obj = getFwdOrdRejectMsg(item); 
				    obj && arrayObj.push(obj); break;

				case appConstants.SWP_ORD_REJECT:
					var obj = getSwpOrdRejectMsg(item); 
					obj && arrayObj.push(obj); break;	

			    case appConstants.SWAP_PLACED:
					  var obj= getSWPTradeConfirmedRemark(item);
					  obj && arrayObj.push(obj);
					  break;

				case appConstants.SWP_REQUEST_RECIEVED:
					  var obj= getSWPTradeRcvdRemark(item);
					  obj && arrayObj.push(obj);
					  break;	

				default: break;
			}
		});
	} catch (e) { console.log(e); }
	//console.log(JSON.stringify(arrayObj));
	return arrayObj;
}
const getReportData = (rptData, reportType = "online") => {
	return rptData.map((item) => {
		let LoopdealType = `${item.isLoopOTO && reportType === "history" ? ' (L)' : ''}`;
		if (parseFloat(item.OT) === appConstants.STOP_ORD_TYPE) {
			item.orderType = `${item.ISOTO ? 'OTO ' : ''}Stop${LoopdealType}`
		} else if (parseFloat(item.OT) === appConstants.OCO_ORD_TYPE) {
			if (parseFloat(item.DOT) === appConstants.STOP_ORD_TYPE) {
				item.orderType = `${item.ISOTO ? 'OTO ' : ''}OCO Stop`
			} else {
				item.orderType = `${item.ISOTO ? 'OTO ' : ''}OCO Limit`
			}
		} else if (parseFloat(item.OT) === appConstants.BMK_ORD_TYPE) {
			item.orderType = "Benchmark"
		} else {
			item.orderType = `${item.ISOTO ? 'OTO ' : ''}Limit${LoopdealType}`;
		}
		return {
			...item
		};
	});
}
// merge position data and loadAccount api STKA data. need to clean this up after .
const updateNonDefAccBal = (nonDefAccBalData, positionData) => {
	try{
	 const updatedSTKA = positionData?.STKA?.map((pos) => {
      const matchedAcc = nonDefAccBalData?.STKA?.find(
        (item) => item.C === pos.suf_code
      );

      return {
        ...pos,
        ...matchedAcc,
      };
    });

    return {
      ...positionData,
	   FD: nonDefAccBalData?.FD,
	   MP: nonDefAccBalData?.MP,
      STKA: updatedSTKA,
    };
  } catch (err) {
    console.log(err);
  }
};
export default function (state = initialState, action) {
	switch (action.type) {
		case types.LOAD_REPORT:
			return {
				...state,
			};
		case types.LOAD_REPORT_SUCCESS:
			return {
				...state,
				reportData: getReportData(JSON.parse(action.result.data), "history"),
				reportPageSize: action.result.totalPages,
			};
		case types.LOAD_REPORT_FAILURE:
			return {
				...state,
			};
		case types.EXPORT_ALLDEAL_REPORT:
			return {
				...state,
			};
		case types.EXPORT_SOA_REPORT:
			return {
				...state,
			};
		case types.EXPORT_POSITION_REPORT:
			return {
				...state,
			};
		case types.LOAD_ALLDEAL_REPORT:
			return {
				...state,
			};
		case types.LOAD_ALLDEAL_REPORT_SUCCESS:
			return {
				...state,
				alldealtbleData: JSON.parse(action.result.data),
				reportPageSize: action.result.totalPages
			};
		case types.LOAD_ALLDEAL_REPORT_FAILURE:
			return {
				...state,
			};
		case types.LOAD_SOA_REPORT:
			return {
				...state,
			};
		case types.LOAD_SOA_REPORT_SUCCESS:
			return {
				...state,
				statement_AccountData: JSON.parse(action.result.data),
				reportPageSize: action.result.totalPages,
			};
		case types.LOAD_SOA_REPORT_FAILURE:
			return {
				...state,
			};
		case types.LOAD_ONLINE_REPORT:
			return {
				...state,
			};
		case types.LOAD_ONLINE_REPORT_SUCCESS:
			return {
				...state,
				OnlinetbleData: getReportData(JSON.parse(action.result.data)),
				reportPageSize: action.result.totalPages,
			};
		case types.LOAD_ONLINE_REPORT_FAILURE:
			return {
				...state,
			};
		case types.LOAD_MARGIN:
			return {
				...state,
				isUpdatePositionData:false
			};
		case types.LOAD_MARGIN_SUCCESS:
			return {
				...state,
				positionData: updatePosition(action.result.data),
				loadRptFlag: false,
				isUpdatePositionData:true
			};
		case 'LOAD_NONDEF_ACC_BALANCE':
		return {
			...state,
			nonDefAccBal:state.positionData,
		};
		case 'LOAD_NONDEF_ACC_BALANCE_SUCCESS':
			return {
				...state,
				nonDefAccBal: updateNonDefAccBal(action.result.data,state.positionData),
				positionData: updateNonDefAccBal(action.result.data,state.positionData),
				isUpdatePositionData: false
			};
		case 'LOAD_NONDEF_ACC_BALANCE_FAILURE':
			return {
				...state,
				nonDefAccBal: state.positionData,
			};
		case types.LOAD_MARGIN_FAILURE:
			return {
				...state,
			}
		case types.ENABLE_LOADER:
			return {
				...state,
				loadRptFlag: action.flag
			};
		case types.LOAD_ACTIVITY_REPORT:
			return {
				...state,
			}
		case types.LOAD_ACTIVITY_REPORT_SUCCESS:
			return {
				...state,
				activityData: generateactivityData(action.result.data),
			}
		case types.LOAD_ACTIVITY_REPORT_FAILURE:
			return {
				...state,
			}
		case types.EXPORT_ACTIVITY_REPORT:
			return {
				...state,
			}
		case types.EXPORT_ORDER_HISTORY_REPORT:
			return {
				...state,
			}
		case types.EXPORT_BM_REPORT:
			return {
				...state,
			}
		case types.LOAD_BENCHMARK_REPORT:
			return {
				...state,
			};
		case types.LOAD_BENCHMARK_REPORT_SUCCESS:
			return {
				...state,
				BMData: JSON.parse(action.result.data),
				reportPageSize: action.result.totalPages,
			};
		case types.LOAD_BENCHMARK_REPORT_FAILURE:
			return {
				...state,
			};
		case types.MODAL_FLAG:
			return {
				...state,
				modalFlag: action.flag,
			};
		case types.RESET_STATE:
			return {
				...state,
				reportData: [],
				alldealtbleData: [],
				statement_AccountData: [],
				activityData: [],
				positionData: {
					totFunds: null,
					totReval: null,
					totABSReval: null,
					totMargin: null,
					curr_NOP: null,
					loss_lmt: null,
					AppMargin: null,
					free_equ: null,
					STKA: [],
					FUNDS: []
				},
				OnlinetbleData: [],
				BMData: [],
				nonDefAccBal:null
			}
		case types.RESET_REPORT_STATE:
			return {
				...initialState
			}
		default:
			return state;
	}
}
